import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from '../../../../../../shared/icons/close-icon.svg';
import { TitleFormattedMessage } from '../../../../../titleFormattedMessage';
import { OptionalMessageInputRef } from '../../../../document-wizard-modal/custom-modals/document-wizard-action-modal/OptionalMessageInputRef';
import { RequestReviewModalComponentProps } from './RequestInternalApprovalModalConstants';
import styles from './RequestApprovalSlideout.module.scss';

const RequestApprovalSlideout = ({
  isOpen,
  onClose,
  modalFilters,
  onSubmit,
  submitDisabled,
  optionalMessageInputRef,
}: RequestReviewModalComponentProps) => {
  // Don't render anything if not showing
  if (!isOpen) {
    return null;
  }

  // Use React Portal to render slideout outside current DOM tree
  return ReactDOM.createPortal(
    <>
      {/* Dark overlay backdrop */}
      {isOpen && <div className={styles.slideoutBackdrop} />}

      <div
        className={classNames(
          styles.slideoutWrapper,
          isOpen ? styles.slideoutWrapper__show : styles.slideoutWrapper__collapsed
        )}
      >
        <div className={styles.slideout}>
          {/* Sticky Header */}
          <div className={styles.slideout__header}>
            <div className={styles.slideout__title}>
              <FormattedMessage id="title.request-internal-review" defaultMessage="Request Internal Review" />
            </div>
            <div className={styles.slideout__close} onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          {/* Scrollable Content */}
          <div className={styles.slideout__content}>
            <div className={styles.slideout__form}>
              {modalFilters}

              <div className={styles.slideout__messageSection}>
                <OptionalMessageInputRef ref={optionalMessageInputRef} />
              </div>
            </div>
          </div>

          {/* Footer with Actions */}
          <div className={styles.slideout__footer}>
            <Button variant="link" className="text-secondary" onClick={onClose}>
              <TitleFormattedMessage id="cta.cancel" defaultMessage="Cancel" />
            </Button>
            <Button variant="secondary" onClick={onSubmit} disabled={submitDisabled}>
              <TitleFormattedMessage id="cta.send-for-review" defaultMessage="Send for review" />
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default RequestApprovalSlideout;
